import React, { useEffect } from "react";
import styles from "./Login.module.scss";
import { FormattedMessage } from "react-intl";
import { IconTheme, TextIconButton } from "@/components/IconButton/IconButton";
import { openUbisoftLoginPopup } from "@/ubisoft/uplay";
import { useNavigate } from "react-router-dom";
import { AccessSteps } from "./AccessSteps";
import { LangSelection } from "../LangSelection";
import { useIsDesktop } from "@/utils/useIsDesktop";
import { metrics } from "../../analytics/events";
import { UserControlsHolder } from "@/components/ArtbookControls/UserControls";
export function Login() {
    var navigate = useNavigate();
    var isDesktop = useIsDesktop();
    useEffect(function () {
        // [WORKAROUND]
        // the login can be mounted for a frame when already logged in when accessing the website
        var timeout = setTimeout(function () {
            metrics.loginPageDisplayed();
        }, 100);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    return (React.createElement("div", { className: styles.loginPage },
        React.createElement("h2", { className: styles.header },
            React.createElement(FormattedMessage, { defaultMessage: "Digital artbook & soundtrack", id: "jCTuVI", tagName: "span" }),
            React.createElement(UserControlsHolder, { className: styles.langPanel },
                React.createElement(LangSelection, null))),
        React.createElement("div", { className: styles.panel },
            !isDesktop && (React.createElement("p", { className: styles.subtitle },
                React.createElement("b", null,
                    React.createElement(FormattedMessage, { defaultMessage: "Please connect to a PC device for full experience", id: "7fZWzx" })))),
            React.createElement("p", null,
                React.createElement(FormattedMessage, { defaultMessage: "Log in with your Ubisoft Account to access and download{br}the <b>digital artbook and soundtrack</b> of the Deluxe Pack & Deluxe Edition.", id: "dRQgTQ", values: FormatP })),
            React.createElement("p", null,
                React.createElement(TextIconButton
                // icon={require("@/public_assets/icon_ubisoft.png")}
                // iconHover={require("@/public_assets/icon_ubisoft_hover.png")}
                , { 
                    // icon={require("@/public_assets/icon_ubisoft.png")}
                    // iconHover={require("@/public_assets/icon_ubisoft_hover.png")}
                    theme: IconTheme.Dark, className: styles.loginButton, onClick: function () {
                        metrics.clickOnLogin();
                        if (process.env.SKIP_LOGIN === "true") {
                            navigate("./artbook");
                        }
                        else {
                            openUbisoftLoginPopup();
                        }
                    } },
                    React.createElement(FormattedMessage, { defaultMessage: "Login", id: "AyGauy" }),
                    React.createElement("img", { src: require("@/public_assets/icon_ubisoft.png"), style: { height: "25px", marginBottom: "1px" } }))),
            React.createElement("p", null,
                React.createElement("span", { className: styles.instructions },
                    React.createElement(FormattedMessage, { defaultMessage: "To access this content you must:", id: "zP8V9W" })),
                React.createElement(AccessSteps, null)))));
}
var FormatP = {
    br: React.createElement("br", null),
    b: function (content) { return React.createElement("b", null, content); },
};
